import type {
  ReasonApi,
  RefundSessionsApi,
  SessionsApi,
  SessionApiQuery,
  SessionCreateApiQuery,
  SessionType,
} from "@/Modules/Models/Api/Sessions";
import type { CanMarkSessionsApi } from "@/Modules/Models/Api/Sessions";

import TherapySideApiService from "./utils/TherapyApi";

class SessionsApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getSessions(customerUuid: string): Promise<SessionsApi> {
    return this.ApiService.get<SessionApiQuery, SessionsApi>({
      endpoint: "v1.0/subscriptions/sessions",
      params: {
        user_uuid: customerUuid,
      },
    });
  }

  createSessions(userUuid: string, attendedAt: number, sessionType: SessionType): Promise<void> {
    return this.ApiService.post<SessionCreateApiQuery, void>({
      endpoint: "v1.0/subscriptions/sessions",
      body: {
        user_uuid: userUuid,
        attended_at: attendedAt,
        type: sessionType,
      },
    });
  }

  refundSessions(customerUuid: string, reasonId: number, reasonComment?: string): Promise<void> {
    return this.ApiService.post<RefundSessionsApi, void>({
      endpoint: `v2.0/subscriptions/sessions/${customerUuid}/refund`,
      body: {
        reason_id: reasonId,
        reason_comment: reasonComment,
      },
    });
  }

  deleteSessions(sessionUuid: string): Promise<void> {
    return this.ApiService.delete<void, void>({
      endpoint: `v1.0/subscriptions/sessions/${sessionUuid}`,
    });
  }

  checkIsSessionRegister(customerUuid: string): Promise<CanMarkSessionsApi> {
    return this.ApiService.get<void, CanMarkSessionsApi>({
      endpoint: `v1.0/subscriptions/sessions/${customerUuid}/check`,
    });
  }

  getRefundReasons(): Promise<ReasonApi[]> {
    return this.ApiService.get<void, ReasonApi[]>({
      endpoint: "v2.0/refunds/reasons",
    });
  }
}

export default SessionsApiConnector;
